// Links out of the app. No imports: plain data.

/** The public documentation site. */
export const DOCS_BASE_URL = "https://docs.telcofy.ai";

/**
 * The docs pages the Home quick-start strip opens. Each path was checked with a HEAD request (2xx).
 * A page that moves falls back to DOCS_BASE_URL here, in one place.
 */
export const DOCS_LINKS = {
  quickStart: `${DOCS_BASE_URL}/api/quickstart`,
  api: `${DOCS_BASE_URL}/api/endpoints`,
  dataDelivery: `${DOCS_BASE_URL}/api/data-delivery`,
} as const;

/** Where people ask for a product that is not in their plan. */
export const SALES_EMAIL = "sales@telcofy.ai";
